"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnuitiesModalForFamilySecured = AnnuitiesModalForFamilySecured;
exports.AnnuitiesModalForRetirement = AnnuitiesModalForRetirement;
exports.AnnuitiesModalForWealth = AnnuitiesModalForWealth;
exports.DisabilityInsuranceModal = DisabilityInsuranceModal;
exports.EducationalSavingsModal = EducationalSavingsModal;
exports.EstatePlanningServicesModalForFamilySecured = EstatePlanningServicesModalForFamilySecured;
exports.EstatePlanningServicesModalForWealth = EstatePlanningServicesModalForWealth;
exports.HsaSavingsAccountsModal = HsaSavingsAccountsModal;
exports.InvestmentSolutionsModalForEducation = InvestmentSolutionsModalForEducation;
exports.InvestmentSolutionsModalForMajorPurchase = InvestmentSolutionsModalForMajorPurchase;
exports.InvestmentSolutionsModalForRetirement = InvestmentSolutionsModalForRetirement;
exports.InvestmentSolutionsModalForWealth = InvestmentSolutionsModalForWealth;
exports.LifeInsuranceModalForEducation = LifeInsuranceModalForEducation;
exports.LifeInsuranceModalForFamilySecured = LifeInsuranceModalForFamilySecured;
exports.LifeInsuranceModalForRetirement = LifeInsuranceModalForRetirement;
exports.LifeInsuranceModalForTransitioningWealth = LifeInsuranceModalForTransitioningWealth;
exports.LongTermCareProtectionModalForFamilySecured = LongTermCareProtectionModalForFamilySecured;
exports.LongTermCareProtectionModalForRetirement = LongTermCareProtectionModalForRetirement;
exports.OtherInvestmentstModal = OtherInvestmentstModal;
exports.RetirementAccountsModalForRetirement = RetirementAccountsModalForRetirement;
exports.RetirementAccountsModalForWealth = RetirementAccountsModalForWealth;
exports.SavingsAccountModal = SavingsAccountModal;
exports.TaxPlanningStrategiesModalForRetirement = TaxPlanningStrategiesModalForRetirement;
exports.TaxPlanningStrategiesModalForWealth = TaxPlanningStrategiesModalForWealth;
exports.TrustServicesModalForFamilySecured = TrustServicesModalForFamilySecured;
exports.TrustServicesModalForWealth = TrustServicesModalForWealth;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Common structure of model
function CommonModalStructure(_ref) {
  var {
    description,
    contentArray
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Learn more")), contentArray.map((section, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index,
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "eyebrow"
  }, section.title), /*#__PURE__*/_react.default.createElement("ul", null, section.content.map((item, idx) => /*#__PURE__*/_react.default.createElement("li", {
    className: "mm-spacing--none",
    key: idx
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: item.url,
    target: "_blank",
    rel: "noreferrer"
  }, item.text)))))));
}

// Content for the Modals (e.g. Descriptions and links for resources)
var investmentSolutionsContentForRetirement = 'Stocks, bonds, mutual funds, ETFs, diversified model portfolios, and separately managed accounts are examples of investment solutions that can help you build wealth toward a secure retirement.';
var investmentSolutionsContentForMajorPurchase = 'Investment solutions create opportunities for your money to grow while saving for a major purchase. Stocks, bonds, mutual funds, ETFs, diversified model portfolios, and separately managed accounts are examples of investment solutions that can help fund future purchases.';
var investmentSolutionsContentForBuildingWealth = 'Stocks, bonds, mutual funds, ETFs, diversified model portfolios, and separately managed accounts are examples of investment solutions that can help you build wealth over time.';
var investmentSolutionsContentEducationalExpenses = 'Investment solutions create opportunities for your money to grow while saving for educational expenses. Stocks, bonds, mutual funds, ETFs, diversified model portfolios, and separately managed accounts are examples of investment solutions that can help fund future educational expenses.';
var investmentSolutionsContentArray = [{
  title: 'Watch',
  content: [{
    text: 'Smart investing through a diversified portfolio',
    url: 'https://www.massmutual.com/financial-wellness/balancing-financial-and-professional-responsibilities?tab=2#managing'
  }]
}, {
  title: 'Read',
  content: [{
    text: 'Investment products and services',
    url: 'https://www.massmutual.com/investment'
  }, {
    text: 'The three keys to choosing your investments',
    url: 'https://blog.massmutual.com/retiring-investing/three-key-investments'
  }]
}];
var retirementAccountsContentForRetirement = 'Retirement savings accounts are specialized investment vehicles, usually with unique tax benefits, designed to help individuals reach the long-term goal of funding their retirement.';
var retirementAccountsContentForWealth = "Retirement savings accounts are specialized investment vehicles, usually with unique tax benefits, designed to help individuals reach the long-term goal of building wealth to help fund retirement.";
var retirementAccountsContentArray = [{
  title: 'Read',
  content: [{
    text: 'Retirement planning',
    url: 'https://www.massmutual.com/financial-wellness/building-a-financial-foundation?tab=0#retirement-prep-under-40'
  }, {
    text: 'Is maxing out your 401(k) enough for retirement?',
    url: 'https://blog.massmutual.com/retiring-investing/401k-not-enough'
  }, {
    text: '8 FAQs on Traditional vs. Roth IRAs',
    url: 'https://blog.massmutual.com/retiring-investing/iras-traditional-roth'
  }]
}];
var annuitiesContentForRetirement = 'Annuities can be a powerful tool for securing a comfortable retirement. By providing a steady income stream, protecting against longevity risk, and offering tax-deferred growth opportunities, annuities address many of the financial challenges retirees face. Explore annuities with a MassMutual financial professional to see if they fit within your overall retirement plan.';
var annuitiesContentForWealth = "Annuities can be a powerful tool for building wealth and providing a guaranteed source of income in retirement. Certain types of annuities can help build wealth as they can grow on a tax-deferred basis, and they can also help protect against longevity risk as they can provide a steady source of lifetime income. Explore annuities with a MassMutual financial professional to see if they fit within your overall financial plan.";
var annuitiesContentForFamilySecured = "Annuities can help ensure your family is financially secure by providing a steady income stream, protecting against longevity risk, and offering tax-deferred growth opportunities. Explore annuities with a MassMutual financial professional to see if they fit within your overall financial plan.";
var annuitiesContentArray = [{
  title: 'Read',
  content: [{
    text: 'MassMutual annuities',
    url: 'https://www.massmutual.com/retirement/annuities'
  }, {
    text: '5 reasons to buy an annuity',
    url: 'https://blog.massmutual.com/retiring-investing/annuity-five-needs'
  }]
}, {
  title: 'Compare',
  content: [{
    text: 'Annuity product comparison',
    url: 'https://www.massmutual.com/retirement/annuities#comparison'
  }]
}];
var lifeInsuranceContentForRetirement = 'In addition to providing a death benefit, some types of life insurance can build cash value on a tax-deferred basis which can be used as a supplemental source of income in retirement.';
var lifeInsuranceContentForTransitioningWealth = "Permanent life insurance can help you pass on to your beneficiaries a tax-free death benefit.";
var lifeInsuranceContentForEducation = "In addition to providing a death benefit, some types of life insurance can provide tax-deferred cash value that can be used to help pay educational expenses.";
var lifeInsuranceContentForFamilySecured = "Life insurance can help protect your loved ones financially in the event of your passing.  Some types offer the opportunity to build cash value which may be used during your lifetime.";
var lifeInsuranceRetirementContentArray = [{
  title: 'Watch',
  content: [{
    text: 'Retirement supplement video',
    url: 'https://www.youtube.com/watch?v=zdVzd-rOePc&list=PLhHtGIhoJmA9l1acAK2P7UFKUdEMu9DPo&index=4'
  }, {
    text: 'Life insurance | Just start',
    url: 'https://www.youtube.com/watch?v=u8BIfXRu9bw&list=PLhHtGIhoJmA9l1acAK2P7UFKUdEMu9DPo&index=7'
  }]
}, {
  title: 'Calculate',
  content: [{
    text: 'Life insurance calculator',
    url: 'https://www.massmutual.com/financial-wellness/calculators/life-insurance-calculator'
  }]
}];
var lifeInsuranceCommonContentArray = [{
  title: 'Watch',
  content: [{
    text: 'Life insurance | Just start',
    url: 'https://www.youtube.com/watch?v=u8BIfXRu9bw&list=PLhHtGIhoJmA9l1acAK2P7UFKUdEMu9DPo&index=7'
  }]
}, {
  title: 'Calculate',
  content: [{
    text: 'Life insurance calculator',
    url: 'https://www.massmutual.com/financial-wellness/calculators/life-insurance-calculator'
  }]
}];
var longTermCareContentForRetirement = "The length of one's retirement may vary and the need for long term care can happen to anyone, at any time. Long term care (LTC) planning may include protecting your assets, retirement funds, and your estate from being depleted to provide care.";
var longTermCareContentForFamilySecured = "There may be a time when you're not able to take care of yourself or your family, especially later in life. Long term care (LTC) planning is designed to meet your health or personal care needs over time. This may include protecting your assets, retirement funds, and your estate from being depleted to provide care.";
var longTermCareContentArray = [{
  title: 'Watch',
  content: [{
    text: 'Will you need long term care?',
    url: 'https://www.massmutual.com/insurance/hybrid-long-term-care-insurance'
  }]
}, {
  title: 'Read',
  content: [{
    text: 'Long term care realities',
    url: 'https://compass.massmutual.com/api/public/assets/file/blt4af9ae143cfe86a5'
  }]
}];
var taxPlanningStrategiesRetirementContent = 'Tax planning is the strategic analysis of a financial situation to ensure that all elements work together to allow you to pay the lowest taxes possible, thus helping maximize your savings for retirement.';
var taxPlanningStrategiesWealthContent = "Tax planning is the strategic analysis of a financial situation to ensure that all elements work together to help you to pay the lowest taxes possible and help maximize your savings and investments.";
var taxPlanningStrategiesContentArray = [{
  title: 'Read',
  content: [{
    text: 'Retirement Investments & Tax Triangle',
    url: 'https://compass.massmutual.com/api/public/assets/file/blte1be35a3859a75e8'
  }]
}];
var hsaSavingsAccountsContent = 'An HSA is a tax-advantaged account that may be available if you have a high deductible health plan. The money contributed to an HSA can help retirees cover the costs of healthcare in a tax-efficient way.';
var hsaSavingsAccountsContentArray = [{
  title: 'Read',
  content: [{
    text: 'What is an HSA? What are its tax benefits?',
    url: 'https://blog.massmutual.com/planning/hsa-explained'
  }]
}];
var estatePlanningServicesContentForWealth = 'The process of planning for the management and distribution of your assets while you are living and after your death, taking into account legal and tax considerations for your beneficiaries.';
var estatePlanningServicesContentForFamilySecured = "Estate planning can help establish your beneficiaries, ensure a smooth transfer of assets, minimize taxes, and limit probate.  Key documents may include a will, power of attorney, healthcare proxy, trusts, gifts, and life insurance.";
var estatePlanningServicesContentArray = [{
  title: 'Watch',
  content: [{
    text: 'Tools to build your estate plan',
    url: 'https://www.massmutual.com/financial-wellness/building-wealth#tools'
  }]
}, {
  title: 'Read',
  content: [{
    text: 'Estate planning guide',
    url: 'https://compass.massmutual.com/api/public/assets/file/blt9a68e00b3ad7c1d2'
  }, {
    text: 'Choosing a trustee',
    url: 'https://blog.massmutual.com/retiring-investing/choosing-a-trustee?_ga=2.245457664.566958573.1729098071-2028214682.1712861104'
  }]
}];
var trustServicesContentForWealth = 'Trust services can offer creative solutions for transitioning wealth. Uses for trusts may include: determining how your money will be managed and distributed while you’re alive or after death, helping your estate avoid taxes and probate, protecting assets from creditors, or dictating the terms of an inheritance for beneficiaries.';
var trustServicesContentForFamilySecured = "Trust services can offer creative solutions for ensuring your family is financially secure. Uses for trusts may include: determining how your money will be managed and distributed while you\u2019re alive or after death, helping your estate avoid taxes and probate, protecting assets from creditors, or dictating the terms of an inheritance for beneficiaries.";
var trustServicesContentArray = [{
  title: 'Read',
  content: [{
    text: 'Is setting up a trust right for you?',
    url: 'https://blog.massmutual.com/planning/wealth-trust-right-for-you'
  }, {
    text: 'Types of trusts and what they are used for',
    url: 'https://blog.massmutual.com/retiring-investing/types-of-trusts'
  }]
}, {
  title: 'Visit',
  content: [{
    text: 'Massmutualtrust.com',
    url: 'https://www.massmutualtrust.com/our-services'
  }]
}];
var savingsAccountContent = "A savings account allows you to earn a rate of interest while maintaining liquidity and may be a solution for storing money for the short term. Savings account interest rates vary by institution.";
var savingsAccountContentArray = [{
  title: 'Watch',
  content: [{
    text: 'Balancing variable and fixed expenses with a spending and saving plan',
    url: 'https://www.massmutual.com/financial-wellness?tab=2#watch'
  }]
}];
var otherInvestmentsContent = "Other investments such as real estate, commodities or cryptocurrency may help you build wealth, but as with all investments, entail risk.";
var educationalSavingsContent = "529 plans and Coverdell Education Savings Accounts (ESAs) are two examples of accounts that offer families effective ways to save for qualified educational costs. Both accounts provide unique, significant advantages such as offering tax benefits, flexibility, and in some cases options for transferring funds if plans change.";
var educationalSavingsContentArray = [{
  title: 'Read',
  content: [{
    text: 'Saving for college',
    url: 'https://www.massmutual.com/financial-wellness/building-a-financial-foundation?tab=0#saving-for-college'
  }, {
    text: 'Getting the most out of your 529 plan',
    url: 'https://blog.massmutual.com/retiring-investing/how-to-make-the-most-from-529-plans'
  }, {
    text: 'How to use custodial accounts and Coverdells',
    url: 'https://blog.massmutual.com/planning/coverdells-custodial-accounts'
  }]
}];
var disabilityInsuranceContent = "If you and/or your loved ones rely on your income, consider whether you're adequately protected.  Disability insurance can help pay a portion of your income if you become ill or injured and are unable to work.";
var disabilityInsuranceContentArray = [{
  title: 'Watch',
  content: [{
    text: 'How much do you know about disability insurance?',
    url: 'https://www.massmutual.com/insurance/disability-income-insurance'
  }]
}, {
  title: 'Read',
  content: [{
    text: 'Disability income insurance overview',
    url: 'https://www.massmutual.com/insurance/disability-income-insurance'
  }]
}];

// ======= Modals Components section =======
function InvestmentSolutionsModalForRetirement(_ref2) {
  var {
    handleClose,
    show
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'InvestmentSolutionsRetirementModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Investment solutions"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: investmentSolutionsContentForRetirement,
    contentArray: investmentSolutionsContentArray
  }))));
}
function InvestmentSolutionsModalForWealth(_ref3) {
  var {
    handleClose,
    show
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'InvestmentSolutionsWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Investment solutions"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: investmentSolutionsContentForBuildingWealth,
    contentArray: investmentSolutionsContentArray
  }))));
}
function InvestmentSolutionsModalForMajorPurchase(_ref4) {
  var {
    handleClose,
    show
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'InvestmentSolutionsMajorPurchaseModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Investment solutions"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: investmentSolutionsContentForMajorPurchase,
    contentArray: investmentSolutionsContentArray
  }))));
}
function InvestmentSolutionsModalForEducation(_ref5) {
  var {
    handleClose,
    show
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'InvestmentSolutionsEducationModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Investment solutions"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: investmentSolutionsContentEducationalExpenses,
    contentArray: investmentSolutionsContentArray
  }))));
}
function RetirementAccountsModalForRetirement(_ref6) {
  var {
    handleClose,
    show
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'RetirementAccountsRetirementModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Retirement accounts"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: retirementAccountsContentForRetirement,
    contentArray: retirementAccountsContentArray
  }))));
}
function RetirementAccountsModalForWealth(_ref7) {
  var {
    handleClose,
    show
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'RetirementAccountsWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Retirement accounts"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: retirementAccountsContentForWealth,
    contentArray: retirementAccountsContentArray
  }))));
}
function AnnuitiesModalForRetirement(_ref8) {
  var {
    handleClose,
    show
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'AnnuitiesRetirementModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Annuities"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: annuitiesContentForRetirement,
    contentArray: annuitiesContentArray
  }))));
}
function AnnuitiesModalForWealth(_ref9) {
  var {
    handleClose,
    show
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'AnnuitiesWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Annuities"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: annuitiesContentForWealth,
    contentArray: annuitiesContentArray
  }))));
}
function AnnuitiesModalForFamilySecured(_ref10) {
  var {
    handleClose,
    show
  } = _ref10;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'AnnuitiesFamilySecuredModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Annuities"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: annuitiesContentForFamilySecured,
    contentArray: annuitiesContentArray
  }))));
}
function LifeInsuranceModalForRetirement(_ref11) {
  var {
    handleClose,
    show
  } = _ref11;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'LifeInsuranceRetirementModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Life insurance"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: lifeInsuranceContentForRetirement,
    contentArray: lifeInsuranceRetirementContentArray
  }))));
}
function LifeInsuranceModalForTransitioningWealth(_ref12) {
  var {
    handleClose,
    show
  } = _ref12;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'LifeInsuranceTransitioningWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Life insurance"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: lifeInsuranceContentForTransitioningWealth,
    contentArray: lifeInsuranceCommonContentArray
  }))));
}
function LifeInsuranceModalForEducation(_ref13) {
  var {
    handleClose,
    show
  } = _ref13;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'LifeInsuranceEducationModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Life insurance"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: lifeInsuranceContentForEducation,
    contentArray: lifeInsuranceCommonContentArray
  }))));
}
function LifeInsuranceModalForFamilySecured(_ref14) {
  var {
    handleClose,
    show
  } = _ref14;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'LifeInsuranceFamilySecuredModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Life insurance"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: lifeInsuranceContentForFamilySecured,
    contentArray: lifeInsuranceCommonContentArray
  }))));
}
function LongTermCareProtectionModalForRetirement(_ref15) {
  var {
    handleClose,
    show
  } = _ref15;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'LongTermCareRetirementModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Long term care protection"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: longTermCareContentForRetirement,
    contentArray: longTermCareContentArray
  }))));
}
function LongTermCareProtectionModalForFamilySecured(_ref16) {
  var {
    handleClose,
    show
  } = _ref16;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'LongTermCareFamilySecuredModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Long term care protection"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: longTermCareContentForFamilySecured,
    contentArray: longTermCareContentArray
  }))));
}
function HsaSavingsAccountsModal(_ref17) {
  var {
    handleClose,
    show
  } = _ref17;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'HsaSavingsAccountModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "HSA savings account"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: hsaSavingsAccountsContent,
    contentArray: hsaSavingsAccountsContentArray
  }))));
}
function TaxPlanningStrategiesModalForRetirement(_ref18) {
  var {
    handleClose,
    show
  } = _ref18;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'TaxPlanningStrategiesRetirementModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Tax planning strategies"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: taxPlanningStrategiesRetirementContent,
    contentArray: taxPlanningStrategiesContentArray
  }))));
}
function TaxPlanningStrategiesModalForWealth(_ref19) {
  var {
    handleClose,
    show
  } = _ref19;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'TaxPlanningStrategiesWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Tax planning strategies"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: taxPlanningStrategiesWealthContent,
    contentArray: taxPlanningStrategiesContentArray
  }))));
}
function EstatePlanningServicesModalForWealth(_ref20) {
  var {
    handleClose,
    show
  } = _ref20;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'EstatePlanningServicesWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Estate planning services"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: estatePlanningServicesContentForWealth,
    contentArray: estatePlanningServicesContentArray
  }))));
}
function EstatePlanningServicesModalForFamilySecured(_ref21) {
  var {
    handleClose,
    show
  } = _ref21;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'EstatePlanningServicesFamilySecuredModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Estate planning services"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: estatePlanningServicesContentForFamilySecured,
    contentArray: estatePlanningServicesContentArray
  }))));
}
function TrustServicesModalForWealth(_ref22) {
  var {
    handleClose,
    show
  } = _ref22;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'TrustServicesWealthModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Trust services"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: trustServicesContentForWealth,
    contentArray: trustServicesContentArray
  }))));
}
function TrustServicesModalForFamilySecured(_ref23) {
  var {
    handleClose,
    show
  } = _ref23;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'TrustServicesFamilySecuredModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Trust services"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: trustServicesContentForFamilySecured,
    contentArray: trustServicesContentArray
  }))));
}
function SavingsAccountModal(_ref24) {
  var {
    handleClose,
    show
  } = _ref24;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'SavingsAccountModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Savings account"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: savingsAccountContent,
    contentArray: savingsAccountContentArray
  }))));
}
function OtherInvestmentstModal(_ref25) {
  var {
    handleClose,
    show
  } = _ref25;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'OtherInvestmentsModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Other investments"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, otherInvestmentsContent)));
}
function EducationalSavingsModal(_ref26) {
  var {
    handleClose,
    show
  } = _ref26;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'EducationalSavingsModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Education savings account"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: educationalSavingsContent,
    contentArray: educationalSavingsContentArray
  }))));
}
function DisabilityInsuranceModal(_ref27) {
  var {
    handleClose,
    show
  } = _ref27;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FinancialPlanningCheckupWizardTool.idPrefix + 'DisabilityInsuranceModal'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Disability insurance"
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement(CommonModalStructure, {
    description: disabilityInsuranceContent,
    contentArray: disabilityInsuranceContentArray
  }))));
}